export default __webpack_public_path__ + "static/media/spring-icon-svgrepo-com.1d88a919.svg";